import * as React from "react";
import * as ReactDOM from "react-dom";
import { SignIn } from "../authentication/SignIn";
import {
  UserContext,
  UserContextModel,
  UserContextContants,
} from "../context/UserContext";
import {
  User,
  Customer,
  Elavtal,
  SelfServiceClient,
  StatusResponse,
} from "../api/ApiClient";
import { SelfServiceContainer } from "./SelfServiceContainer";
import moment from "moment";
import { sessionListener, emitSessionChange } from "./SessionListener";
import { Config } from "../api/Config";
import { createHashHistory } from "history";

interface Props {}

interface State extends UserContextModel {
  signedOut: boolean;
}

class SelfServiceApp extends React.Component<Props, State> {
  private selfServiceClient = new SelfServiceClient();
  constructor(props: Props) {
    super(props);

    let elavtal = sessionStorage.getItem(UserContextContants.elavtalStorage)
      ? (
          JSON.parse(
            sessionStorage.getItem(UserContextContants.elavtalStorage)
          ) as any[]
        ).map((elavtal: any): Elavtal => Elavtal.fromJS(elavtal))
      : [];
    let currentElavtalId = sessionStorage.getItem(
      UserContextContants.currentElavtalStorage
    );
    let currentElavtal = currentElavtalId
      ? elavtal.find((elavtal) => elavtal.id == currentElavtalId)
      : undefined;
    let token =
      sessionStorage.getItem(UserContextContants.tokenStorage) || undefined;

    if (token) {
      this.selfServiceClient.setToken(token);
    }

    this.state = {
      token,
      user: sessionStorage.getItem(UserContextContants.userStorage)
        ? User.fromJS(
            JSON.parse(sessionStorage.getItem(UserContextContants.userStorage))
          )
        : undefined,
      customer: sessionStorage.getItem(UserContextContants.customerStorage)
        ? Customer.fromJS(
            JSON.parse(
              sessionStorage.getItem(UserContextContants.customerStorage)
            )
          )
        : undefined,
      elavtal,
      currentElavtal,
      getClient: this.getClient,
      setToken: this.setToken,
      setUser: this.setUser,
      setCustomer: this.setCustomer,
      setElavtal: this.setElavtal,
      setCurrentElavtal: this.setCurrentElavtal,
      clear: this.clear,
      signedOut: false,
    };

    sessionListener((signedIn: boolean) => this.sessionUpdate(signedIn));
  }

  sessionUpdate = (signedIn: boolean) => {
    !signedIn && this.clear();
  };

  getClient = () => {
    return this.selfServiceClient;
  };

  setToken = (token: string) => {
    this.setState({
      token,
    });

    this.selfServiceClient.setToken(token);
    sessionStorage.setItem(UserContextContants.tokenStorage, token);
    emitSessionChange(!!token);
  };

  setUser = (user: User) => {
    this.setState({
      user,
    });
    sessionStorage.setItem(
      UserContextContants.userStorage,
      JSON.stringify(user)
    );
  };

  setCustomer = (customer: Customer) => {
    this.setState({
      customer,
    });
    sessionStorage.setItem(
      UserContextContants.customerStorage,
      JSON.stringify(customer)
    );
  };

  setElavtal = (elavtal: Elavtal[]) => {
    let currentElavtal = elavtal && elavtal.length > 0 ? elavtal[0] : undefined;
    this.setState({
      elavtal,
      currentElavtal,
    });
    sessionStorage.setItem(
      UserContextContants.elavtalStorage,
      JSON.stringify(elavtal)
    );
    if (currentElavtal) {
      sessionStorage.setItem(
        UserContextContants.currentElavtalStorage,
        currentElavtal.id
      );
    }
  };

  setCurrentElavtal = (currentElavtal: Elavtal) => {
    this.setState({
      currentElavtal,
    });
    sessionStorage.setItem(
      UserContextContants.currentElavtalStorage,
      currentElavtal.id
    );
  };

  clear = () => {
    this.setState({
      token: undefined,
      user: undefined,
      customer: undefined,
      elavtal: undefined,
      currentElavtal: undefined,
      signedOut: true,
    });
    this.selfServiceClient.setToken(undefined);
    sessionStorage.removeItem(UserContextContants.tokenStorage);
    sessionStorage.removeItem(UserContextContants.userStorage);
    sessionStorage.removeItem(UserContextContants.customerStorage);
    sessionStorage.removeItem(UserContextContants.elavtalStorage);
    sessionStorage.removeItem(UserContextContants.currentElavtalStorage);
  };

  onSignedIn = (response: StatusResponse) => {
    this.setToken(response.token);
    this.setUser(response.user);
  };

  render() {
    return (
      <div>
        <UserContext.Provider value={this.state}>
          <h1>Mina sidor</h1>
          <p className="copy">
            Här kan du läsa om din el, din förbrukning och allt sånt där tråkigt
            som vi försökt få bort från ditt liv.
          </p>
          {this.state.token && this.state.user ? (
            <SelfServiceContainer />
          ) : (
            <SignIn
              signedOut={this.state.signedOut}
              onCompleted={this.onSignedIn}
            />
          )}
        </UserContext.Provider>
      </div>
    );
  }
}

moment.locale("sv");

declare var ClientConfig: Config;
const browserHistory = createHashHistory({ basename: "" });
ReactDOM.render(
  <SelfServiceApp />,
  document.getElementById("self-service-app")
);
